import React from "react"
import UxToolTip from "@next/ux-tooltip"
import {UxCTA as CTA} from "@next/ux-cta"
import {
    ToolTipUsername,
    Divider,
    SignoutButton,
    ToolTipContent,
    TooltipFooter,
    TooltipHeader,
    ToolTipTitle,
    ViewAccountSummaryLink,
} from "../../component"
import {MyAccountLoggedInTooltipProps} from "../.."
import LoggedInTooltipUsername from "../../../MyAccountLoggedInTooltipUsername"
import Icon from "../../../Icon"

import {NO_FOLLOW} from "../../../../config/constants"
import {removeDeptFromSessionStorage} from "../../../../utils/removeDeptFromSessionStorage"

export const loggedinTooltipTestid = (el?: string) => `header-my-account-container${el ? `-${el}` : ""}`

export const LoggedInTooltip = ({
    open,
    anchorEl,
    handleClose,
    tooltipIcon,
    accessibilityText,
    url,
    text,
    firstName,
    signoutUrl,
    placement,
    enableModArrow,
    showStaticHeaderBanner,
}: MyAccountLoggedInTooltipProps) => {
    return (
        <UxToolTip
            open={open}
            ref={anchorEl}
            handleClose={handleClose}
            animationTimeout={300}
            placement={placement}
            enableModArrow={enableModArrow}
            modifiers={[
                {
                    name: "offset",
                    options: {
                        enabled: true,
                        offset: [0, showStaticHeaderBanner ? 7 : 18],
                    },
                },
            ]}
        >
            <ToolTipContent data-testid={loggedinTooltipTestid()}>
                <TooltipHeader>
                    <ViewAccountSummaryLink
                        onClick={removeDeptFromSessionStorage}
                        data-testid={loggedinTooltipTestid("tooltip-link")}
                    >
                        <Icon src={tooltipIcon} alt={accessibilityText} />
                        <ToolTipTitle>
                            <a href={url} rel={NO_FOLLOW} data-testid={loggedinTooltipTestid("tooltip-title")}>
                                {text.title}
                            </a>
                        </ToolTipTitle>
                    </ViewAccountSummaryLink>
                    <Divider />
                </TooltipHeader>
                <TooltipFooter>
                    <ToolTipUsername>
                        <LoggedInTooltipUsername notText={text.notText as string} firstName={firstName as string} />
                    </ToolTipUsername>
                    <SignoutButton data-testid={loggedinTooltipTestid("tooltip-signout")}>
                        <CTA
                            color="secondary"
                            state="enabled"
                            variant="outlined"
                            size="medium"
                            url={signoutUrl}
                            text={text.buttonText}
                        />
                    </SignoutButton>
                </TooltipFooter>
            </ToolTipContent>
        </UxToolTip>
    )
}
export default LoggedInTooltip
